import { t } from "@lingui/macro";
import React from "react";

import { Crementor } from "@whoosh/design-system/src/components/controls/Crementor";
import { Avatar } from "@whoosh/design-system/src/components/display";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

type UnknownCustomerCounterType = {
  checkNewDisabled?: boolean;
  isDecrementDisabled?: boolean;
  isIncrementDisabled?: boolean;
  unknownCustomerLimit?: number;
  unknownCustomerCount: number;
  onAddUnknownCustomer?: () => void;
  onRemoveUnknownCustomer?: () => void;
  playerNounOverride?: {
    singular: string;
    plural: string;
  };
};

const UnknownCustomerCounter = ({
  checkNewDisabled,
  isDecrementDisabled,
  isIncrementDisabled,
  onAddUnknownCustomer,
  unknownCustomerLimit,
  unknownCustomerCount,
  onRemoveUnknownCustomer,
  playerNounOverride,
}: UnknownCustomerCounterType) => {
  const unknownCustomerName = playerNounOverride?.singular ?? t`Player`;
  const shouldDisableIncrement = checkNewDisabled || isIncrementDisabled;

  return (
    <HStack
      pt={10}
      pb={5}
      mx={6}
      justifyContent="space-between"
      alignItems="center"
      borderBottomWidth={1}
      borderBottomColor="grayscale-200"
      opacity={!unknownCustomerCount && checkNewDisabled ? 0.5 : 1}
    >
      <HStack alignItems="center">
        <Avatar type="customer" size="sm" />
        <Text marginLeft={4}>{t`New ${unknownCustomerName}`}</Text>
      </HStack>
      <Crementor
        min={0}
        max={unknownCustomerLimit}
        value={unknownCustomerCount}
        onIncrement={onAddUnknownCustomer}
        onDecrement={onRemoveUnknownCustomer}
        isDecrementDisabled={isDecrementDisabled}
        isIncrementDisabled={shouldDisableIncrement}
      />
    </HStack>
  );
};

export default UnknownCustomerCounter;
